/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversationAutomationItem } from '../../models/api-response-conversation-automation-item';

export interface StartConversationAiAssistance$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  conversationReference: string;
}

export function startConversationAiAssistance(http: HttpClient, rootUrl: string, params: StartConversationAiAssistance$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationAutomationItem>> {
  const rb = new RequestBuilder(rootUrl, startConversationAiAssistance.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('conversationReference', params.conversationReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversationAutomationItem>;
    })
  );
}

startConversationAiAssistance.PATH = '/api/ai-assistant/conversation/{conversationReference}/start';
